import { usePrivy } from '@privy-io/react-auth';
import { DropdownIcon } from 'assets/icons/DropdownIcon';
import { WalletDisconnectDropdown } from 'components/DisconnectWalletDropdown';

export function WalletMenu() {
  const { user, ready} = usePrivy();
  
  const userName = user?.twitter?.username;

  if (!ready || !user) {
    return <></>;
  }

  return (
    <>
      <WalletDisconnectDropdown>
        <button className="flex items-center gap-2 p-[0.6875rem] md:px-5 md:py-[0.9375rem] bg-white bg-opacity-[.06] font-bold text-sm leading-5">
          <span className='hidden md:flex items-center gap-2'>
            {userName && `@${userName}`}
            <DropdownIcon />
          </span>
        </button>
      </WalletDisconnectDropdown>
    </>
  );
}
